import { removeBannerService } from "../infrastructure/services/removeBannerService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const removeBanner = {
  async execute(position: string): Promise<void> {
    await removeBannerService.execute(await tokenValidation.execute(), position);
  },
};
